import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

export class ListField extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="project-on-board-list-field">Page Content: project-on-board/ListField</div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListField);
